import { PresetField } from './preset-field.model';

export class PresetsGroup {
  id: string;
  displayName: string;
  fields: PresetField[];
  groupId: string;
}
